/* global $, jQuery */
'use strict';

(function ($) {
	window.addEventListener('load', function() {
		localStorage.removeItem('cart'); // This removes the item
	});
function toggle_cart() {

	$("#stock-cart__form").toggle( 200, function(){
		$('.js-cart-toggle').toggleClass( 'js-cart--show' );
	});
}
function createFancyVisibleItem( id, sku, reference, price_discounted, quantity, pvp, discount ) {
	var cart_table = $('#js-cart-table');
	// client fancy
	cart_table.append(`<tr id="id-${id}">
		<td>${sku}</td><td>${reference}</td><td>${pvp}</td><td>${discount}%</td><td>${price_discounted}</td><td>${quantity}</td>
		<td><a class="stock-cart__remove-item js-cart__remove-item" data-product_id="${id}" data-product_sku="${sku}" data-product_pvp="${pvp}" data-product_discount="${discount}">${$( ".email__cart-label-remove" ).text()}</a></td>
		</tr>`);
}
function createCartHiddenItem( id, sku, reference, price_discounted, quantity ) {
	var productFields = document.getElementById('js-cart__refs');
	var cart_line = document.createElement('div');
	cart_line.className='cart-line';
	cart_line.id= id; //'sku-' + safe_sku;
	// Create new input fields
	var productIdInput = document.createElement('input');
	productIdInput.type = 'hidden';
	productIdInput.type = 'text';
	productIdInput.name = 'email_order__refs[]';
	productIdInput.value = sku;

	var productNameInput = document.createElement('input');
	productNameInput.type = 'hidden';
	productNameInput.type = 'text';
	productNameInput.name = 'email_order__names[]';
	productNameInput.value = reference;

	var productPriceInput = document.createElement('input');
	productPriceInput.type = 'hidden';
	productPriceInput.type = 'text';
	productPriceInput.name = 'email_order__prices[]';
	productPriceInput.value = price_discounted;

	var productQuantityInput = document.createElement('input');
	productQuantityInput.type = 'text';
	productQuantityInput.name = 'email_order__quantities[]';
	productQuantityInput.value = quantity;

	// Append the new fields to the productFields div
	cart_line.appendChild(productIdInput);
	cart_line.appendChild(productNameInput);
	cart_line.appendChild(productPriceInput);
	cart_line.appendChild(productQuantityInput);
	cart_line.appendChild(document.createElement('br'));
	productFields.appendChild( cart_line );
}
// Add Items To Basket
function addToBasket( id, sku, reference, pvp, discount, price_discounted, quantity ) {

	if (!discount) {
		discount = 0;
	}

	// real data to order
	createCartHiddenItem( id, sku, reference, price_discounted, quantity );
	// fancy table
	createFancyVisibleItem( id, sku, reference, price_discounted, quantity, pvp, discount );

	//Make calculations
	var current_pvp      = parseFloat($('#js-cart__totals-pvp').html().slice(0, -2).replace(',', '.'));
	var current_discount = parseFloat($('#js-cart__totals-discount').html().slice(0, -2).replace(',', '.'));
	var current_total    = parseFloat($('#js-cart__totals-total').html().slice(0, -2).replace(',', '.'));

	const pvp_f = parseFloat( pvp );
	var totals_pvp      = (current_pvp + pvp_f ).toFixed(2);
	var totals_discount = (current_discount + ( pvp_f * discount / 100)).toFixed(2);
	var totals_total    = (current_total + pvp_f - ( pvp_f * discount / 100)).toFixed(2);

	// 0 build item
    const item = { id, sku, reference, price_discounted, quantity, pvp, discount };

    // 1. Add the item to the cart (in-memory array)
    let cart = JSON.parse(localStorage.getItem('cart')) || [];
    cart.push(item);

    // 2. Save the updated cart back to localStorage
    localStorage.setItem('cart', JSON.stringify(cart));

	$('#js-cart__totals-pvp').html(totals_pvp.replace('.', ',') + ' €');
	$('#js-cart__totals-discount').html(totals_discount.replace('.', ',') + ' €');
	$('#js-cart__totals-total').html(totals_total.replace('.', ',') + ' €');
}

//Remove Items From Basket
function removeCartHiddenItem( id ) {
	$( '#js-cart__refs #id-' + id ).remove();
}
function removeFromBasket( id, sku, pvp, discount) {

	removeCartHiddenItem( id );

	var current_pvp      = parseFloat($('#js-cart__totals-pvp').html().slice(0, -2).replace(',', '.'));
	var current_discount = parseFloat($('#js-cart__totals-discount').html().slice(0, -2).replace(',', '.'));
	var current_total    = parseFloat($('#js-cart__totals-total').html().slice(0, -2).replace(',', '.'));

	var totals_pvp      = (current_pvp - pvp).toFixed(2);
	var totals_discount = (current_discount - (pvp * discount / 100)).toFixed(2);
	var totals_total    = (Math.abs(current_total - (pvp - (pvp * discount / 100)))).toFixed(2);

	totals_pvp = totals_discount.replace('.', ',');
	totals_discount = totals_discount.replace('.', ',');
	totals_total = totals_total.replace('.', ',');

	if ( isNaN( totals_pvp ) ) {
		totals_pvp = 0;
	}
	if ( isNaN( totals_discount ) ) {
		totals_discount = 0;
	}
	if ( isNaN( totals_total ) ) {
		totals_total = 0;
	}

	$('#js-cart__totals-pvp').html( totals_pvp + ' €' );
	$('#js-cart__totals-discount').html( totals_discount + ' €');
	$('#js-cart__totals-total').html( totals_total + ' €');

	$("#id-" + id ).remove();

}
function maybe_clear_cart() {
	const element = document.querySelector('.gos_mail__success');
	if (element) {
		// Element with class 'maybe_success' exists, trigger the function
		clear_cart_and_baskets();
	}
}
function clear_cart_and_baskets() {
	// visual cart js
	var cart = document.getElementById('js-cart-table');
	cart.innerHTML = '';

	// hidden order cart
	var basket = document.getElementById( 'js-cart__refs');
	basket.innerHTML = '';

	// clear local storage
	localStorage.removeItem( 'cart' );

}

function updateBasket() {
	// Get cart from local storage and update the HTML
	var cart = getCart();
	var cartItemsElement = document.getElementById('js-cart-table');

	if ( cartItemsElement === undefined || cartItemsElement === null ) {
		return;
	}

	// Clear existing items
	cartItemsElement.innerHTML = '';

	// Add each item to the cart and calculate total
	cart.forEach(function(item) {

		//var self = $(this);
		const id        = item.id;
		const sku       = item.sku;
		const reference = item.reference;
		const pvp       = item.pvp;
		const discount  = item.discount;
		const price     = item.price;
		const quantity  = item.quantity;

		addToBasket( id, sku, reference, pvp, discount, price, quantity );
	});

}
function getCart() {
	// Retrieve cart from local storage, or initialize an empty array
	return JSON.parse(localStorage.getItem('cart')) || [];
}
function saveCart(cart) {
	// Save cart to local storage
	localStorage.setItem('cart', JSON.stringify(cart));
}
function removeFromCart(id) {
	// Remove item from cart array
	var cart = getCart();
	var updatedCart = cart.filter(function(item) {
		return item.id != id;
	});

	// Save updated cart to local storage
	saveCart(updatedCart);

	// Update cart on the page
	updateBasket();
}

$(document).on('click', '.js-cart__remove-item', function (e) {
	var self = $(this);
	var id       = '' + self.data('product_id');
	var sku      = '' + self.data('product_sku');
	var pvp      = self.data('product_pvp');
	var discount = self.data('product_discount');
	removeFromCart( id );
	removeFromBasket( id, sku, pvp, discount );
}),

$(document).on('click', '.js-cart-toggle', function (e) {
	e.preventDefault(),
	toggle_cart();
}),

$(document).on( 'click', '.js-add__cart', function(e) {
	e.preventDefault();

	var self = $(this);
	var sku       = self.data('product_sku');
	var reference = self.data('product_name');
	var pvp       = self.data('product_pvp');
	var discount  = self.data('product_discount');
	var price     = self.data('price_discounted');
	var quantity  = 1;
	if ( $(this).hasClass('js-ask-avail') ) {
		quantity = 'Pedir Prazo de Entrega';
	}

	// Add item to cart array
	var cart = getCart();
	const currentTime = new Date().getTime().toString();
	cart.push(
		{
			id: sku + '-' + currentTime,
			sku: sku,
			reference: reference,
			pvp: pvp,
			discount: discount,
			price: price,
			quantity: quantity,
		}
	);

	// Save cart to local storage
	saveCart(cart);

	addToBasket(
		sku + '-' + currentTime,
		String( sku ),
		reference,
		pvp,
		discount,
		price,
		quantity );

	let product_overlay = $(this).parent().parent().find(".js-product__overlay");
	product_overlay
	.css({
		'transform': ' translateY(0px)',
		'opacity': '1',
		'transition': 'all ease-in-out .45s'
	}).delay(1500).queue(function() {
		$(this).css({
			'transform': 'translateY(-500px)',
			'opacity': '0',
			'transition': 'all ease-in-out .45s'
		}).dequeue();
	});

	let product_overlay2 = $(this).parent().find(".js-inline-product__overlay");
	product_overlay2.css({
		'display': 'flex',
		'transform': ' translateY(0px)',
		'opacity': '1',
		'transition': 'all ease-in-out .45s'
	}).delay(1500).queue(function() {
		$(this).css({
			'display': 'none',
			'transform': 'translateY(-500px)',
			'opacity': '0',
			'transition': 'all ease-in-out .45s'
		}).dequeue();
	}
	);
});


jQuery(document).ready(function( $ ) {
	// init
	maybe_clear_cart();
});

}(jQuery));
